import styleInject from './../../../externals/style-inject/dist/style-inject.es.js';

var css_248z = ".ContinueToDeliveryButton-module_continueToDelivery__bAcSm {\n  max-width: none;\n  width: 100%;\n}";
var styles = {"continueToDelivery":"ContinueToDeliveryButton-module_continueToDelivery__bAcSm"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=ContinueToDeliveryButton.module.scss.js.map
